import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  icon: any;
  label: string | number;
  isButton?: boolean;
  iconFlip?: 'horizontal' | 'vertical' | 'both';
  iconSize?: any;
  containerStyle?: string;
  iconStyle?: string;
  labelStyle?: string;
  onClick?: () => void;
}

const FaIconView: React.FC<Props> = (props) => {
  const {
    icon,
    label,
    isButton,
    iconFlip,
    iconSize,
    containerStyle,
    iconStyle,
    labelStyle,
    onClick,
  } = props;

  return (
    <div
      className={containerStyle}
      role={isButton ? 'button' : ''}
      onClick={onClick}
    >
      <FontAwesomeIcon
        className={iconStyle}
        icon={icon}
        flip={iconFlip}
        size={iconSize}
      />
      <p className={labelStyle}>{label}</p>
    </div>
  );
};

export default FaIconView;
